import { Divider, Header } from 'semantic-ui-react'
import { Section } from '../Shared/Section'
import { CheckoutSystemCard } from './Cards/CheckoutSystemCard'

const IntegrationSection = () => {
    return (
      <>
          <Divider horizontal>
              <Header as="h4" color="teal">
                  Intégrations
              </Header>
          </Divider>

          <Section>
              <CheckoutSystemCard />
          </Section>
      </>
    )
}

export { IntegrationSection }
